import styled from 'styled-components';
export const EmptyStateActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
  max-width: 750px;
  width: 100%;
  height: 100%;
  padding-inline: 60px;
  margin: auto;
  padding-block-end: ${({ theme }) => theme.spacing.md}px;
  justify-content: center;
  align-items: center;
`;
